/* eslint-disable no-param-reassign */
import browser, { dom } from '../../../../browser';

const ACE_VERSION = '1.13.0';
const BASE_PATH = `https://cdnjs.cloudflare.com/ajax/libs/ace/${ACE_VERSION}`;

const ACE_PATH = `${BASE_PATH}/ace.js`;
const HIGHLIGHT_PATH = `${BASE_PATH}/ext-static_highlight.js`;

let isAceLoading = false;
const aceLoadingPromisesResolvers = [];

function isAceReady() {
  return !!browser.window.ace;
}

function getInstance() {
  if (isAceReady()) {
    return Promise.resolve(browser.window.ace);
  }

  return new Promise((resolve) => {
    aceLoadingPromisesResolvers.push(resolve);

    if (isAceLoading) {
      return;
    }

    isAceLoading = true;

    dom
      .insertScript(ACE_PATH)
      .then(() => dom.insertScript(HIGHLIGHT_PATH))
      .then(() => {
        const { ace } = browser.window;

        ace.config.set('basePath', BASE_PATH);
        ace.config.set('modePath', BASE_PATH);
        ace.config.set('themePath', BASE_PATH);
        ace.config.set('workerPath', BASE_PATH);

        aceLoadingPromisesResolvers.forEach((resolver) => resolver(ace));
        isAceLoading = false;
      });
  });
}

function hideCodeEditor(domElement, editorElement) {
  domElement.style.display = 'block';
  editorElement.remove();
}

function showCodeEditor(event, aceInstance, domElement, container) {
  event.preventDefault();

  const editor = aceInstance.edit(null, {
    value: domElement.textContent.trim(),
    showLineNumbers: false,
    highlightActiveLine: false,
    showGutter: true,
    highlightGutterLine: false,
    fontSize: 12,
  });

  editor.container.style.height = `${domElement.clientHeight}px`;
  editor.container.style.marginTop = '25px';

  domElement.style.display = 'none';
  container.appendChild(editor.container);

  editor.selectAll();
  editor.focus();

  /* istanbul ignore next */
  editor.addEventListener('blur', () => hideCodeEditor(domElement, editor.container));
}

function syntaxHighlight(domElement, container, language, showGutter) {
  return getInstance().then((ace) => {
    ace.require('ace/ext/static_highlight')(domElement, {
      mode: `ace/mode/${language}`,
      theme: 'ace/theme/dracula',
      startLineNumber: 1,
      showGutter,
      trim: true,
    });

    const isOnQuizPage = window.location.href.includes('exercises');

    if (!isOnQuizPage) {
      /* istanbul ignore next */
      domElement.addEventListener('click', (event) =>
        showCodeEditor(event, ace, domElement, container)
      );
    }
  });
}

export default {
  isAceReady,
  getInstance,
  syntaxHighlight,
  showCodeEditor,
  hideCodeEditor,
};
